'use strict';

export class init {
    constructor(opt) {
        this.opt = opt;
        this.bindHandlers();
    }

    bindHandlers() {
        let _self = this;

        $('#wallet-refill').click(function () {
            if (false === _self.opt.loggedIn) {
                window.location.href = _self.opt.loginPath;
                return false;
            }

            let btn = $(this);
            btn.prop('disabled', true);
            $.post(_self.opt.refillPath, {amount: $('#wallet-refill-amount').val()}).done(function (data) {
                if (data.success) {
                    window.location.reload();
                } else {
                    toastr.error(data.message);
                }

                btn.prop('disabled', false);
            });
        });

        $('#wallet-start-payment').click(function () {
            if ($(this).hasClass('disabled')) {
                return;
            }

            $.post(_self.opt.startPaymentPath).done(function (data) {
                if (data.popup) {
                    $('body').append(data.popup);
                } else {
                    toastr.error(data.message);
                }
            });
        });

        $(document).on('click', '#wallet-confirm-payment', function (e) {
            e.preventDefault();
            $.post($(this).attr('data-path')).done(function (data) {
                if (data.popup) {
                    $('body').append(data.popup);
                } else {
                    toastr.error(data.message);
                }
            });
        });

        $(document).on('click', '#wallet-payment-success-btn', function () {
            window.location.href = _self.opt.mainPagePath;
        });
    }
}